import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './spinner.css';

export default class Spinner extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        size: PropTypes.number,
        className: PropTypes.string
    }

    static defaultProps = {
        color: '#08AF99',
        size: 50,
        className: null
    }

    render() {
        return (
            <span className={this.props.className}>
                <svg
                    className='spinner'
                    width={`${this.props.size}px`}
                    height={`${this.props.size}px`}
                    viewBox='0 0 66 66'
                    xmlns='http://www.w3.org/2000/svg'>
                    <circle
                        className='path'
                        fill='none'
                        stroke={this.props.color}
                        strokeWidth='6'
                        strokeLinecap='round'
                        cx='33'
                        cy='33'
                        r='30' />
                </svg>
            </span>
        );
    }
}
